import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import {
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@internal/backstage-plugin-techradar-exxcellent';

export class TechRadarClient implements TechRadarApi {
  #discoveryApi: DiscoveryApi;
  #fetchApi: FetchApi;

  constructor(discoveryApi: DiscoveryApi, fetchApi: FetchApi) {
    this.#discoveryApi = discoveryApi;
    this.#fetchApi = fetchApi;
  }

  async load(/*id?: string*/): Promise<TechRadarLoaderResponse> {
    const apiBaseUrl = await this.#discoveryApi.getBaseUrl('techradar');
    const res = await this.#fetchApi.fetch(`${apiBaseUrl}/inventory`);
    const data = await res.json();

    return {
      ...data,
      entries: data.entries.map((entry: { timeline: any[] }) => ({
        ...entry,
        timeline: entry.timeline
          .sort((a, b) => (Date.parse(a.date) >= Date.parse(b.date) ? -1 : 1))
          .map(timeline => ({
            ...timeline,
            date: new Date(timeline.date),
          })),
      })),
    };
  }
}
